export const questionnairesDe = {
  nav: {
    field: 'Außendienst',
    cockpit: 'Außendienst-Cockpit',
    runs: 'Durchführungen',
    templates: 'Fragebögen',
    results: 'Fragebogen-Ergebnisse',
  },
  permissions: {
    denied: 'Für diesen Bereich fehlt die erforderliche Fragebogen-Berechtigung.',
  },
  statuses: {
    DRAFT: 'Entwurf',
    PUBLISHED: 'Veröffentlicht',
    ARCHIVED: 'Archiviert',
    IN_PROGRESS: 'In Bearbeitung',
    PAUSED: 'Pausiert',
    COMPLETED: 'Abgeschlossen',
    ABANDONED: 'Abgebrochen',
    SYNC_PENDING: 'Synchronisierung ausstehend',
    SYNC_FAILED: 'Synchronisierung fehlgeschlagen',
  },
  sync: {
    online: 'Online',
    offline: 'Offline',
    syncing: 'Synchronisierung läuft',
    pending: 'Ausstehend',
    failed: 'Fehler',
    synced: 'Synchronisiert',
    retry: 'Synchronisierung erneut versuchen',
    conflict: 'Der Server enthält eine neuere Fassung. Prüfen Sie den Konflikt.',
  },
  questionTypes: {
    SHORT_TEXT: 'Kurzer Text',
    LONG_TEXT: 'Mehrzeiliger Text',
    NUMBER: 'Zahl',
    DECIMAL: 'Dezimalzahl',
    CURRENCY: 'Währung',
    PERCENTAGE: 'Prozent',
    PERCENT: 'Prozent',
    DATE: 'Datum',
    TIME: 'Uhrzeit',
    DATE_TIME: 'Datum und Uhrzeit',
    DATETIME: 'Datum und Uhrzeit',
    YES_NO: 'Ja / Nein',
    CHECKBOX: 'Checkbox',
    SINGLE_CHOICE: 'Einfachauswahl',
    RADIO: 'Einfachauswahl',
    MULTIPLE_CHOICE: 'Mehrfachauswahl',
    MULTI_CHOICE: 'Mehrfachauswahl',
    DROPDOWN: 'Dropdown',
    COMBOBOX: 'Durchsuchbare Auswahl',
    RATING_SCALE: 'Bewertungsskala',
    STAR_RATING: 'Sternebewertung',
    SLIDER: 'Schieberegler',
    EMAIL: 'E-Mail-Adresse',
    PHONE: 'Telefonnummer',
    URL: 'Webadresse',
    ADDRESS: 'Adresse',
    HEADING: 'Überschrift',
    INFORMATION: 'Informationstext',
    INFO_TEXT: 'Informationstext',
    DIVIDER: 'Trennlinie',
    FILE_UPLOAD: 'Datei-Upload',
    PHOTO: 'Fotoaufnahme',
    IMAGE_GALLERY: 'Bildergalerie',
    SIGNATURE: 'Unterschrift',
    CONSENT: 'Einwilligung / Datenschutz',
    PRODUCT_SINGLE: 'Produktauswahl',
    PRODUCT_MULTIPLE: 'Produkt-Mehrfachauswahl',
    PRODUCT_MULTI: 'Produkt-Mehrfachauswahl',
    PRODUCT_CATALOG: 'Produktkatalog',
    PRODUCT_QUANTITY_LIST: 'Produkt-Mengenliste',
    REPEATABLE_GROUP: 'Wiederholbare Gruppe',
  },
  scopes: {
    EXISTING_CUSTOMER: 'Bestandskunde',
    NEW_CUSTOMER: 'Neukunde',
    PROSPECT: 'Interessent',
    SUPPLIER: 'Lieferant',
    PARTNER: 'Geschäftspartner',
    PARTNERLESS: 'Ohne Partner',
    OTHER: 'Sonstiger Anlass',
  },
  cockpit: {
    title: 'Außendienst-Cockpit',
    subtitle: 'Befragungen starten, fortsetzen und sicher nachbearbeiten.',
    newRun: 'Neue Befragung',
    partnerless: 'Partnerlose Befragung',
    today: 'Heutige Durchführungen',
    drafts: 'Entwürfe',
    paused: 'Pausierte Befragungen',
    unsynced: 'Nicht synchronisiert',
    followUp: 'Nachbearbeitung erforderlich',
    recentTemplates: 'Zuletzt verwendete Vorlagen',
    recentPartners: 'Zuletzt verwendete Partner',
    search: 'Durchführungen durchsuchen',
    searchPlaceholder: 'Vorlage, Partner oder Kontakt',
    allStatuses: 'Alle Status',
    allTemplates: 'Alle Vorlagen',
    empty: 'Noch keine Befragungen vorhanden.',
    emptyHint: 'Starten Sie die erste Befragung im Außendienst-Cockpit.',
    loadError: 'Das Außendienst-Cockpit konnte nicht geladen werden.',
    summaryLoadError: 'Die Cockpit-Kennzahlen konnten nicht geladen werden.',
    continue: 'Fortsetzen',
    review: 'Nachbearbeiten',
    progress: '{{value}} %',
  },
  start: {
    title: 'Neue Befragung',
    subtitle: 'Partner, Kontakt und veröffentlichte Vorlage auswählen.',
    context: 'Ausgangssituation',
    withPartner: 'Mit Geschäftspartner',
    withoutPartner: 'Ohne vorhandenen Partner',
    partner: 'Geschäftspartner',
    partnerSearch: 'Partner suchen',
    partnerSearchPlaceholder: 'Firma, Name, E-Mail oder Partnernummer',
    contact: 'Ansprechpartner',
    noContact: 'Ohne Ansprechpartner',
    template: 'Vorlage',
    matchingTemplates: 'Passende Vorlagen',
    extendedTemplates: 'Weitere veröffentlichte Vorlagen',
    showExtended: 'Erweiterte Auswahl anzeigen',
    noTemplates: 'Für diesen Kontext ist keine veröffentlichte Vorlage verfügbar.',
    create: 'Befragung anlegen',
    creating: 'Befragung wird angelegt',
    created: 'Die Befragung wurde angelegt.',
    createError: 'Die Befragung konnte nicht angelegt werden.',
    partnerlessData: 'Optionale Kontaktdaten',
    company: 'Firma',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    phone: 'Telefon',
    address: 'Adresse',
    source: 'Quelle',
    note: 'Notiz',
    contactConsent: 'Einwilligung zur Kontaktaufnahme liegt vor',
    sourcePlaceholder: 'z. B. Messe oder Außendienstbesuch',
    noPartnerRequired:
      'Alle Kontaktdaten dürfen leer bleiben, sofern die Vorlage nichts anderes verlangt.',
    fromPartner: 'Fragebogen starten',
    fromContact: 'Fragebogen für Kontakt starten',
  },
  run: {
    loading: 'Befragung wird geladen.',
    loadError: 'Die Befragung konnte nicht geladen werden.',
    notFound: 'Die Befragung wurde nicht gefunden oder darf nicht geöffnet werden.',
    answers: 'Antworten',
    files: 'Dateien und Fotos',
    products: 'Produkte',
    internal: 'Nur für Mitarbeitende',
    required: 'Pflichtfeld',
    notApplicable: 'Nicht anwendbar',
    hidden: 'Durch Regel ausgeblendet',
    saveState: 'Speicherstatus',
    saved: 'Alle Änderungen gespeichert.',
    saving: 'Änderungen werden gespeichert.',
    saveFailed: 'Änderungen konnten nicht gespeichert werden.',
    localSaved: 'Entwurf verschlüsselt auf diesem Gerät gespeichert.',
    start: 'Befragung starten',
    pause: 'Pausieren',
    resume: 'Fortsetzen',
    abandon: 'Abbrechen',
    complete: 'Befragung abschließen',
    completeTitle: 'Befragung abschließen?',
    completeDescription:
      'Die Antworten werden serverseitig geprüft und danach unveränderbar festgeschrieben.',
    completeSuccess: 'Die Befragung wurde abgeschlossen.',
    completeError: 'Die Befragung konnte nicht abgeschlossen werden.',
    pauseSuccess: 'Die Befragung wurde pausiert.',
    abandonTitle: 'Befragung abbrechen?',
    abandonDescription: 'Der Abbruch bleibt nachvollziehbar protokolliert.',
    abandonSuccess: 'Die Befragung wurde abgebrochen.',
    customerMode: 'Kundenmodus starten',
    customerModeHint: 'Prüfen Sie Partner und Vorlage, bevor Sie das Gerät übergeben.',
    handoverTitle: 'Gerät an den Kunden übergeben',
    handoverDescription:
      'Der Kundenmodus blendet die ERP-Oberfläche aus und zeigt nur freigegebene Fragen.',
    handoverConfirm: 'Kundenmodus aktivieren',
    revision: 'Korrekturrevision anlegen',
    sectionProgress: 'Abschnitt {{current}} von {{total}}',
    questionProgress: 'Frage {{current}} von {{total}}',
    validationError: 'Bitte prüfen Sie die markierten Pflichtfelder.',
  },
  renderer: {
    yes: 'Ja',
    no: 'Nein',
    choose: 'Bitte auswählen',
    search: 'Optionen durchsuchen',
    noOptions: 'Keine passenden Optionen',
    selectedCount: '{{count}} ausgewählt',
    addGroup: 'Weiteren Eintrag hinzufügen',
    removeGroup: 'Eintrag entfernen',
    groupLabel: 'Eintrag {{index}}',
    repeatMissing: 'Die konfigurierte Unterfrage ist nicht verfügbar.',
    repeatUnsupported:
      '„{{label}}“ kann in einer wiederholbaren Gruppe nicht sicher gespeichert werden.',
    addressStreet: 'Straße',
    addressHouseNumber: 'Hausnummer',
    addressPostalCode: 'Postleitzahl',
    addressCity: 'Ort',
    addressCountry: 'Land',
    clear: 'Eingabe löschen',
    stars: '{{count}} von {{max}} Sternen',
    signatureHint: 'Bitte innerhalb des Feldes unterschreiben.',
    signerName: 'Name der unterzeichnenden Person',
    signatureChooseImage: 'PNG-Unterschrift auswählen',
    signatureClear: 'Unterschrift löschen',
    signatureDisclaimer:
      'Die gezeichnete Unterschrift ist keine qualifizierte elektronische Signatur.',
    consentName: 'Name der bestätigenden Person',
    consentConfirmed: 'Ich bestätige die angezeigte Einwilligung.',
    consentVersion: 'Dokumentversion {{version}}',
  },
  media: {
    addFile: 'Datei auswählen',
    takePhoto: 'Foto aufnehmen',
    takeRearPhoto: 'Foto mit Rückkamera',
    takeFrontPhoto: 'Foto mit Frontkamera',
    chooseGallery: 'Aus Galerie wählen',
    preview: 'Vorschau',
    previewReady: 'Vorschau – noch nicht übernommen',
    accept: 'Foto oder Datei übernehmen',
    retake: 'Neu aufnehmen',
    rotate: 'Drehen',
    remove: 'Datei entfernen',
    description: 'Beschreibung',
    queued: 'Für Upload vorgemerkt',
    uploading: 'Upload {{progress}} %',
    uploaded: 'Sicher hochgeladen',
    uploadFailed: 'Upload fehlgeschlagen',
    deleteFailed: 'Die Datei konnte nicht sicher gelöscht werden.',
    retryUpload: 'Upload wiederholen',
    cameraUnavailable: 'Die Kamera ist in diesem Browser nicht verfügbar.',
    permissionDenied: 'Der Kamerazugriff wurde nicht erlaubt. Prüfen Sie die Browserberechtigung.',
    invalidFile: 'Die Datei entspricht nicht den erlaubten Formaten oder Größen.',
    metadataHint: 'Bildmetadaten werden vor der dauerhaften Ablage serverseitig entfernt.',
    empty: 'Noch keine Datei ausgewählt.',
  },
  products: {
    search: 'Produkte suchen',
    searchPlaceholder: 'Artikelname oder Artikelnummer',
    empty: 'Keine passenden Produkte gefunden.',
    unknown: 'Nicht mehr im aktuellen Katalog',
    loadError: 'Die Produkte konnten nicht geladen werden.',
    selected: 'Ausgewählt',
    selectedProduct: 'Ausgewähltes Produkt',
    select: 'Produkt auswählen',
    remove: 'Produkt entfernen',
    articleNumber: 'Artikelnummer',
    quantity: 'Gewünschte Menge',
    packaging: 'Verpackungseinheit',
    packagingLabel: '{{name}} ({{code}})',
    interest: 'Interesse',
    currentProduct: 'Aktuelles Wettbewerbsprodukt',
    currentUse: 'Produkt wird aktuell eingesetzt',
    comparisonGroup: 'Produktvergleich / Vergleichsgruppe',
    plannedPurchaseDate: 'Geplantes Kaufdatum',
    note: 'Bemerkung',
    photo: 'Produktfoto',
    photoFileName: 'Produktfoto',
    wishlist: 'Zur Merkliste hinzufügen',
    priceRestricted: 'Preise werden in dieser Kundenansicht nicht angezeigt.',
    available: 'Verfügbar',
    unavailable: 'Derzeit nicht verfügbar',
    interestLevels: {
      NONE: 'Kein Interesse',
      LOW: 'Gering',
      MEDIUM: 'Mittel',
      HIGH: 'Hoch',
    },
  },
  customer: {
    completedBrand: 'Befragung',
    loading: 'Fragebogen wird sicher geöffnet.',
    unavailableTitle: 'Fragebogen nicht verfügbar',
    unavailable:
      'Die Kundenmodus-Sitzung ist abgelaufen oder wurde beendet. Bitte geben Sie das Gerät an die betreuende Person zurück.',
    fullscreen: 'Vollbild öffnen',
    fullscreenExit: 'Vollbild verlassen',
    fullscreenFailed: 'Der Browser konnte den Vollbildmodus nicht aktivieren.',
    welcomeHeading: 'Willkommen',
    privacyNoticeHeading: 'Datenschutzhinweis',
    titleImageAlt: 'Titelbild zu {{title}}',
    privacyTitle: 'Inhalte sind verdeckt',
    privacyDescription: 'Die Ansicht wurde wegen Inaktivität oder eines Tabwechsels gesperrt.',
    privacyAction: 'An Mitarbeitende übergeben',
    inactive: 'Die Ansicht wurde wegen Inaktivität gesperrt.',
    tabHidden: 'Die Inhalte bleiben nach dem Tabwechsel verdeckt.',
    previous: 'Zurück',
    next: 'Weiter',
    finish: 'Antworten absenden',
    thankYouTitle: 'Vielen Dank',
    thankYou:
      'Ihre Antworten wurden sicher übermittelt. Bitte geben Sie das Gerät an die betreuende Person zurück.',
    noErpAccess: 'Diese Ansicht bietet keinen Zugang zum ERP.',
    unlockTitle: 'Mitarbeiter-Entsperrung',
    unlockDescription:
      'Die Rückkehr zur internen Nachbearbeitung erfordert eine erneute Mitarbeiterbestätigung.',
    password: 'Aktuelles Mitarbeiterpasswort',
    unlock: 'Nachbearbeitung entsperren',
    unlockFailed: 'Die Mitarbeiterbestätigung ist fehlgeschlagen.',
    unlockSuccess: 'Die interne Nachbearbeitung wurde entsperrt.',
    cleanupFailed:
      'Die lokalen Fragebogendaten konnten noch nicht sicher entfernt werden. Bitte erneut versuchen.',
    cleanupRetry: 'Lokale Daten erneut entfernen',
    securityLimit:
      'Der Kundenmodus ist ein Sichtschutz der Webanwendung. Betriebssystemfunktionen, Screenshots und andere Browser-Tabs können nicht vollständig kontrolliert werden.',
  },
  offline: {
    supported: 'Sichere Offline-Nutzung verfügbar',
    unavailable: 'Sichere Offline-Nutzung ist in diesem Browser nicht verfügbar.',
    unavailableSensitive:
      'Diese sensible Vorlage kann ohne sichere Verschlüsselung nicht offline verwendet werden.',
    encryption:
      'Lokale Entwürfe und Medien werden mit Web Crypto verschlüsselt in IndexedDB gespeichert.',
    preparing: 'Offline-Daten werden vorbereitet.',
    prepared: 'Vorlage ist offline verfügbar.',
    packageCount: '{{count}} Offline-Vorlage(n) sicher vorgeladen.',
    preloadFailed: 'Offline-Vorlagen konnten nicht aktualisiert werden.',
    partnerContextRequired:
      'Partnerbezogene Befragungen können offline nur mit sicher vorgeladenem Partnerkontext gestartet werden.',
    localRunCreated: 'Die Befragung wurde sicher offline angelegt.',
    customerPageUnavailable:
      'Diese Seite wurde noch nicht verschlüsselt vorgeladen. Stellen Sie eine Verbindung her, um fortzufahren.',
    customerCompletionPending:
      'Die Antworten sind verschlüsselt auf diesem Gerät gespeichert und werden bei wiederhergestellter Verbindung abgeschlossen.',
    localRunSyncing: 'Die Offline-Befragung wird mit dem Server synchronisiert.',
    localRunConflict:
      'Der Serverstand hat sich geändert. Die lokalen Daten bleiben verschlüsselt erhalten.',
    cleanup: 'Lokale Daten wurden nach erfolgreicher Synchronisierung entfernt.',
  },
  postprocess: {
    title: 'Nachbearbeitung',
    subtitle: 'Ergebnisse prüfen und ERP-Aktionen bewusst übernehmen.',
    completeness: 'Vollständigkeitsprüfung',
    complete: 'Vollständig',
    incomplete: 'Unvollständig',
    partnerAssignment: 'Partnerzuordnung',
    currentPartner: 'Zugeordneter Partner',
    partnerless: 'Noch keinem Partner zugeordnet',
    searchPartner: 'Vorhandenen Partner suchen',
    linkPartner: 'Partner verknüpfen',
    linked: 'Der Geschäftspartner wurde verknüpft.',
    linkError: 'Der Geschäftspartner konnte nicht verknüpft werden.',
    createProspect: 'Neuen Interessenten anlegen',
    createCustomer: 'Neuen Kunden anlegen',
    duplicates: 'Mögliche Dubletten',
    duplicateCheck: 'Dublettenprüfung vor der Anlage',
    noDuplicates: 'Keine möglichen Dubletten gefunden.',
    duplicatesAcknowledged: 'Ich habe die möglichen Dubletten geprüft und bestätige die Neuanlage.',
    conversionConfirmation:
      'Die Stammdaten werden in der Vorschau geprüft und erst nach Ihrer Bestätigung über die bestehende Partnerlogik angelegt und verknüpft.',
    confirmConversion: 'Neuanlage bestätigen und verknüpfen',
    converted: '{{name}} wurde angelegt und mit der Befragung verknüpft.',
    conversionError:
      'Die Neuanlage konnte nicht ausgeführt werden. Prüfen Sie Pflichtfelder und mögliche Dubletten.',
    proposedActions: 'Vorgeschlagene ERP-Aktionen',
    preview: 'Vorschau der Übernahme',
    confirm: 'Ausgewählte Aktion ausführen',
    confirmationRequired: 'Die Aktion wird erst nach Ihrer ausdrücklichen Bestätigung ausgeführt.',
    noSilentChanges: 'Es erfolgen keine stillen Stammdatenänderungen.',
    actionSuccess: 'Die ERP-Aktion wurde ausgeführt.',
    actionError: 'Die ERP-Aktion konnte nicht ausgeführt werden.',
    dueAt: 'Fällig am',
    assignmentRequired: 'Vor dieser Aktion muss ein Geschäftspartner zugeordnet sein.',
    contactData: 'Kontaktdaten des neuen Ansprechpartners',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail-Adresse',
    phone: 'Telefonnummer',
    leadStatus: 'Neue Pipeline-Stufe',
    leadStatuses: {
      NEW: 'Neu',
      CONTACTED: 'Kontaktiert',
      QUALIFIED: 'Qualifiziert',
      PROPOSAL_SENT: 'Angebot gesendet',
      NEGOTIATION: 'Verhandlung',
      WON: 'Gewonnen',
      LOST: 'Verloren',
    },
    actions: {
      CREATE_QUOTE_DRAFT: 'Angebotsentwurf erstellen',
      CREATE_ORDER_DRAFT: 'Auftragsentwurf erstellen',
      CREATE_PROSPECT_NEED: 'Interessentenbedarf übernehmen',
      CREATE_PARTNER_NOTE: 'Partnernotiz erstellen',
      CREATE_FOLLOW_UP: 'Follow-up anlegen',
      CREATE_TASK: 'Aufgabe anlegen',
      ADD_CONTACT: 'Ansprechpartner ergänzen',
      UPDATE_PROSPECT_PIPELINE: 'Interessenten-Pipeline aktualisieren',
      EXPOSE_DMS_FILES: 'Dateien in Partnerakte anzeigen',
      SAVE_PRODUCT_INTEREST: 'Produktinteresse speichern',
      ADD_PRODUCT_WATCHLIST: 'Produkte zur Merkliste hinzufügen',
    },
  },
  templates: {
    title: 'Fragebogen-Vorlagen',
    subtitle: 'Versionierte Vorlagen erstellen, prüfen und veröffentlichen.',
    create: 'Neue Vorlage',
    createTitle: 'Vorlage anlegen',
    internalName: 'Interner Name',
    visibleTitle: 'Sichtbarer Titel',
    description: 'Beschreibung',
    language: 'Sprache',
    applications: 'Anwendungsbereiche',
    version: 'Version {{version}}',
    updatedAt: 'Geändert {{date}}',
    empty: 'Noch keine Fragebogen-Vorlage vorhanden.',
    loadError: 'Die Vorlagen konnten nicht geladen werden.',
    created: 'Die Vorlage wurde angelegt.',
    duplicate: 'Vorlage duplizieren',
    archive: 'Vorlage archivieren',
    archived: 'Die Vorlage wurde archiviert.',
    edit: 'Builder öffnen',
  },
  builder: {
    title: 'Formular-Builder',
    back: 'Zur Vorlagenliste',
    palette: 'Komponenten',
    workspace: 'Formular',
    properties: 'Eigenschaften',
    templateProperties: 'Vorlage',
    sections: 'Abschnitte',
    addSection: 'Abschnitt hinzufügen',
    sectionTitle: 'Abschnittsüberschrift',
    sectionDescription: 'Abschnittsbeschreibung',
    untitledSection: 'Unbenannter Abschnitt',
    untitledQuestion: 'Unbenannte Frage',
    selectHint: 'Wählen Sie eine Frage oder einen Abschnitt aus.',
    dragHint: 'Ziehen oder per Tastatur in die Arbeitsfläche einfügen.',
    keyboardHint: 'Leertaste aufnehmen, Pfeiltasten verschieben, Leertaste ablegen.',
    save: 'Entwurf speichern',
    saved: 'Der Vorlagenentwurf wurde gespeichert.',
    saveError: 'Der Vorlagenentwurf konnte nicht gespeichert werden.',
    unsaved: 'Ungespeicherte Änderungen',
    discardTitle: 'Ungespeicherte Änderungen verwerfen?',
    discardDescription:
      'Beim Versionswechsel gehen die noch nicht gespeicherten Änderungen dieser Version verloren.',
    discardChanges: 'Änderungen verwerfen',
    validate: 'Validieren',
    valid: 'Die Vorlage ist veröffentlichungsfähig.',
    invalid: 'Die Vorlage enthält noch fachliche Fehler.',
    publish: 'Veröffentlichen',
    publishTitle: 'Vorlagenversion veröffentlichen?',
    publishDescription: 'Die veröffentlichte Version wird unveränderbar eingefroren.',
    published: 'Die Vorlagenversion wurde veröffentlicht.',
    publishError: 'Die Vorlagenversion konnte nicht veröffentlicht werden.',
    preview: 'Vorschau',
    previewHint: 'Prüfen Sie Darstellung und Logik in den unterstützten Gerätebreiten.',
    previewDevice: 'Vorschaugerät',
    devices: {
      phone: 'Smartphone',
      tablet: 'Tablet',
      desktop: 'Desktop',
    },
    addQuestion: 'Frage hinzufügen',
    createDraft: 'Neue Entwurfsversion erstellen',
    deleteSection: 'Abschnitt entfernen',
    repeatChild: 'Unterfrage',
    copySuffix: '(Kopie)',
    duplicateQuestion: 'Frage duplizieren',
    deleteQuestion: 'Frage entfernen',
    moveUp: 'Nach oben verschieben',
    moveDown: 'Nach unten verschieben',
    internalKey: 'Stabiler interner Schlüssel',
    label: 'Bezeichnung',
    helpText: 'Hilfetext',
    placeholder: 'Platzhalter',
    prefillPartnerField: 'Aus Geschäftspartnerfeld vorbelegen',
    erpTargetField: 'Spätere Zuordnung zum ERP-Feld',
    analyticsKey: 'Auswertungskennzeichen',
    required: 'Pflichtfeld',
    internal: 'Nur intern',
    customerVisible: 'Im Kundenmodus sichtbar',
    searchable: 'Für Auswertung markiert',
    sensitive: 'Sensible Daten',
    sensitivity: {
      NONE: 'Keine sensible Klassifizierung',
      PERSONAL: 'Personenbezogene Daten',
      SPECIAL_CATEGORY: 'Besondere Kategorie personenbezogener Daten',
      CONFIDENTIAL_BUSINESS: 'Vertrauliche Geschäftsdaten',
    },
    minLength: 'Minimale Länge',
    maxLength: 'Maximale Länge',
    minValue: 'Minimalwert',
    maxValue: 'Maximalwert',
    decimals: 'Dezimalstellen',
    step: 'Schrittweite',
    address: {
      requireStreet: 'Straße verlangen',
      requirePostalCode: 'Postleitzahl verlangen',
      requireCity: 'Ort verlangen',
      requireCountry: 'Land verlangen',
    },
    pattern: 'Sicherer regulärer Ausdruck',
    validationMessage: 'Validierungsmeldung',
    defaultValue: 'Standardwert',
    noDefault: 'Kein Standardwert',
    clearDefault: 'Standardwert entfernen',
    options: 'Auswahloptionen',
    optionValue: 'Stabiler Wert',
    optionLabel: 'Bezeichnung',
    optionDescription: 'Beschreibung',
    translations: 'Übersetzungen',
    primaryLanguage: 'Primärsprache',
    locales: {
      tr: 'Türkisch',
      fr: 'Französisch',
      es: 'Spanisch',
      de: 'Deutsch',
      en: 'Englisch',
    },
    titleImage: 'Optionales Titelbild aus dem DMS',
    titleImageUpload: 'Titelbild hochladen',
    titleImageRemove: 'Titelbild entfernen',
    titleImageEmpty: 'Im DMS sind noch keine Bilder verfügbar.',
    titleImageError: 'Die DMS-Bilder konnten nicht geladen oder hochgeladen werden.',
    titleImageDmsPermission: 'Für die Auswahl eines Titelbilds fehlt die DMS-Leseberechtigung.',
    removeChip: '{{value}} entfernen',
    addOption: 'Option hinzufügen',
    moveOptionUp: 'Option nach oben verschieben',
    moveOptionDown: 'Option nach unten verschieben',
    allowedFileFormats: 'Erlaubte Dateiformate',
    fileFormats: {
      PDF: 'PDF',
      JPEG: 'JPEG',
      PNG: 'PNG',
      WEBP: 'WebP',
      DOCX: 'Word (DOCX)',
      XLSX: 'Excel (XLSX)',
      TXT: 'Textdatei (TXT)',
      CSV: 'CSV',
    },
    newOption: 'Option {{index}}',
    removeOption: 'Option entfernen',
    randomizeOptions: 'Optionen zufällig sortieren',
    minSelections: 'Minimale Auswahlanzahl',
    maxSelections: 'Maximale Auswahlanzahl',
    maxFiles: 'Maximale Dateianzahl',
    maxFileSizeMb: 'Maximale Dateigröße in MB',
    requireFileDescription: 'Dateibeschreibung verlangen',
    imageSource: 'Erlaubte Bildquelle',
    imageSources: { CAMERA: 'Kamera', GALLERY: 'Galerie', BOTH: 'Kamera und Galerie' },
    requireSignerName: 'Name der unterzeichnenden Person verlangen',
    logic: 'Bedingte Logik',
    addRule: 'Regel hinzufügen',
    removeRule: 'Regel entfernen',
    operators: {
      EQUALS: 'gleich',
      NOT_EQUALS: 'ungleich',
      CONTAINS: 'enthält',
      NOT_CONTAINS: 'enthält nicht',
      GREATER_THAN: 'größer als',
      LESS_THAN: 'kleiner als',
      EMPTY: 'ist leer',
      NOT_EMPTY: 'ist nicht leer',
      ONE_OF: 'eine von',
      ALL_OF: 'alle von',
      BETWEEN: 'im Bereich',
    },
    consentText: 'Einwilligungstext',
    consentPurpose: 'Zweck der Einwilligung',
    consentSignature: 'Unterschrift verlangen',
    repeatChildren: 'Unterfragen',
    pageBreak: 'Seitenumbruch nach diesem Abschnitt',
    completionSection: 'Abschlussabschnitt',
    consentDocumentVersion: 'Dokumentversion',
    consentWithdrawal: 'Widerrufshinweis',
    consentName: 'Namen der bestätigenden Person verlangen',
    productFilters: 'Produktfilter',
    productDisplay: 'Produktanzeige und Antwortfelder',
    productFilter: {
      productIds: 'Konkrete Artikel',
      categoryIds: 'Kategorien',
      productGroups: 'Produktgruppen',
      tags: 'Tags',
      rootCategoryId: 'Oberste Kategorie',
      searchProducts: 'Artikelname oder Artikelnummer suchen',
      searchCategories: 'Kategorien durchsuchen',
      selectedItem: 'Ausgewählter Artikel',
      removeSelected: 'Ausgewählten Artikel entfernen',
      clearProducts: 'Artikelauswahl leeren',
      allCategories: 'Alle Kategorien',
      productTypes: 'Artikeltypen',
      activeOnly: 'Nur aktive Artikel',
      customerSpecificAssortment: 'Kundenspezifisches Sortiment',
      availableOnly: 'Nur verfügbare Ware',
      includeSubcategories: 'Unterkategorien einschließen',
    },
    productTypes: {
      STOCK: 'Lagerartikel',
      NON_STOCK: 'Nicht-Lagerartikel',
      SERVICE: 'Dienstleistung',
      SET: 'Set',
      DEPOSIT: 'Pfandartikel',
    },
    productDisplayFields: {
      showImage: 'Produktbild',
      showName: 'Artikelname',
      showArticleNumber: 'Artikelnummer',
      showDescription: 'Beschreibung',
      showPackaging: 'Verpackungseinheiten',
      showPrice: 'Preis',
      showStock: 'Bestand',
      showCategories: 'Kategorien',
      showTags: 'Tags',
      allowQuantity: 'Mengeneingabe',
      allowInterest: 'Interesse',
      allowCurrentUse: 'Aktueller Einsatz',
      allowPlannedPurchaseDate: 'Geplantes Kaufdatum',
      allowCompetitorProduct: 'Wettbewerbsprodukt',
      allowRemark: 'Bemerkung',
      allowComparison: 'Produktvergleich',
      allowProductPhoto: 'Produktfoto',
      allowWatchlist: 'Merkliste',
    },
    minRows: 'Minimale Einträge',
    maxRows: 'Maximale Einträge',
    addButtonLabel: 'Beschriftung für „Hinzufügen“',
    ruleIf: 'Wenn',
    ruleOperator: 'Operator',
    ruleValue: 'Vergleichswert',
    conditionSourceQuestion: 'Quellfrage der Bedingung',
    conditionOperator: 'Operator der Bedingung',
    ruleAction: 'Dann',
    combination: 'Verknüpfung',
    settings: 'Vorlageneinstellungen',
    welcomeText: 'Begrüßungstext',
    completionText: 'Abschlusstext',
    privacyText: 'Datenschutztext',
    estimatedMinutes: 'Geschätzte Dauer in Minuten',
    useTenantLogo: 'Mandantenlogo anzeigen',
    customerMode: 'Kundenmodus erlauben',
    allowBackNavigation: 'Zurück-Navigation erlauben',
    fullscreen: 'Vollbild anbieten',
    idleLockMinutes: 'Inaktivitätssperre in Minuten',
    offlineMode: 'Offline-Nutzung erlauben',
    allowSensitiveOffline: 'Sensible Daten offline erlauben',
    preloadProductLimit: 'Maximal vorzuladende Produkte',
    progress: 'Fortschrittsanzeige',
    oneQuestionPerPage: 'Eine Frage pro Seite',
    oneSectionPerPage: 'Ein Abschnitt pro Seite',
    hiddenAnswerPolicy: 'Umgang mit ausgeblendeten Antworten',
    hiddenPolicies: {
      DELETE: 'Antwort löschen',
      MARK_NOT_APPLICABLE: 'Als nicht anwendbar markieren',
    },
    conditions: 'Bedingungen',
    addCondition: 'Bedingung hinzufügen',
    removeCondition: 'Bedingung entfernen',
    logicTarget: 'Ziel',
    combinators: { AND: 'UND', OR: 'ODER' },
    logicActions: {
      SHOW: 'Anzeigen',
      HIDE: 'Ausblenden',
      SKIP_TO_SECTION: 'Zu Abschnitt springen',
      MARK_NOT_APPLICABLE: 'Als nicht anwendbar markieren',
    },
    optimisticConflict:
      'Die Vorlage wurde zwischenzeitlich geändert. Laden Sie die aktuelle Fassung neu.',
  },
  results: {
    title: 'Fragebogen-Ergebnisse',
    subtitle: 'Durchführungen filtern, prüfen und kontrolliert exportieren.',
    detailTitle: 'Ergebnisdetails',
    analytics: 'Auswertung',
    search: 'Ergebnisse durchsuchen',
    template: 'Vorlage',
    version: 'Version',
    status: 'Status',
    period: 'Zeitraum',
    employee: 'Mitarbeiter',
    partner: 'Partner',
    partnerRole: 'Partnerrolle',
    partnerless: 'Partnerlos',
    completeness: 'Vollständigkeit',
    product: 'Produkt',
    date: 'Datum',
    contact: 'Kontakt',
    duration: 'Dauer',
    durationMinutes: '{{value}} Min.',
    attachments: 'Dateien / Fotos',
    selectedProducts: 'Produkte',
    syncStatus: 'Synchronisierung',
    postprocessStatus: 'Nachbearbeitung',
    empty: 'Keine Ergebnisse für die gewählten Filter.',
    loadError: 'Die Ergebnisse konnten nicht geladen werden.',
    exportCsv: 'Liste als CSV exportieren',
    exportJson: 'Strukturierten JSON-Export erstellen',
    exportPdf: 'PDF-Bericht öffnen',
    exportSuccess: 'Der Export wurde erstellt.',
    exportQueued: 'Der Export wurde als Hintergrundauftrag gestartet.',
    exportJobTitle: '{{format}}-Export',
    exportRows: '{{count}} Ergebnisse',
    exportProgress: 'Fortschritt des Exportauftrags',
    exportDownload: 'Export herunterladen',
    exportFailed: 'Der Export ist fehlgeschlagen ({{code}}).',
    exportUnknownError: 'Unbekannter Fehler',
    exportLoadError: 'Die Exportaufträge konnten nicht geladen werden.',
    exportStatuses: {
      PENDING: 'Wartet',
      PROCESSING: 'Wird erstellt',
      COMPLETED: 'Bereit',
      FAILED: 'Fehlgeschlagen',
    },
    answers: 'Antworten nach Abschnitt',
    consents: 'Einwilligungen',
    audit: 'Audit-Timeline',
    transfers: 'ERP-Übernahmen',
    revisions: 'Revisionen',
    syncEvents: 'Synchronisierungsereignisse',
    distribution: 'Antwortverteilung',
    average: 'Durchschnitt',
    trend: 'Zeitliche Entwicklung',
    completionRate: 'Abschlussrate',
    abandonmentRate: 'Abbruchrate',
    averageDuration: 'Durchschnittliche Bearbeitungsdauer',
    noAnalytics: 'Keine für Auswertungen freigegebenen Fragen vorhanden.',
    analyticsError: 'Die aggregierte Auswertung konnte nicht geladen werden.',
    allTemplates: 'Alle Vorlagen',
    allRoles: 'Alle Partnerrollen',
    allCompleteness: 'Vollständig und unvollständig',
    employeeId: 'Mitarbeiter-ID',
    productId: 'Produkt-ID',
    productCategory: 'Produktkategorie',
    categoryId: 'Kategorie-ID',
    analyticsKey: 'Auswertungskennzeichen',
    answerOperator: 'Antwortoperator',
    answerValue: 'Antwortwert',
    startedCount: 'Gestartet',
    completedCount: 'Abgeschlossen',
    numericSummary: 'Ø {{average}} · Min. {{minimum}} · Max. {{maximum}}',
    productInterests: 'Produktinteressen',
    roleDistribution: 'Verteilung nach Partnerrolle',
    startedShort: 'G {{value}}',
    completedShort: 'A {{value}}',
    abandonedShort: 'B {{value}}',
    partnerRoles: {
      CUSTOMER: 'Kunde',
      PROSPECT: 'Interessent',
      SUPPLIER: 'Lieferant',
      PARTNERLESS: 'Partnerlos',
    },
    dateFrom: 'Von',
    dateTo: 'Bis',
    revoked: 'Widerrufen',
    revisionNumber: 'Revision {{number}}',
    createRevision: 'Korrekturrevision erstellen',
    revisionDescription:
      'Die Korrektur erzeugt eine neue nachvollziehbare Revision. Das Original bleibt erhalten.',
    revisionReason: 'Begründung der Korrektur',
    previewRevision: 'Korrektur prüfen',
    confirmRevision: 'Revision verbindlich erstellen',
    revisionCreated: 'Die Korrekturrevision wurde erstellt.',
    revisionError: 'Die Korrekturrevision konnte nicht erstellt werden.',
    systemActor: 'System',
    targetEntity: 'Ziel: {{type}} · {{id}}',
    eventStatuses: {
      PENDING: 'Ausstehend',
      PROCESSING: 'Wird verarbeitet',
      SUCCEEDED: 'Erfolgreich',
      FAILED: 'Fehlgeschlagen',
    },
    syncEventTypes: {
      DRAFT_CREATED: 'Lokaler Entwurf angelegt',
      ANSWERS_SAVED: 'Antworten synchronisiert',
      ATTACHMENT_QUEUED: 'Datei vorgemerkt',
      ATTACHMENT_UPLOADED: 'Datei hochgeladen',
      COMPLETION_REQUESTED: 'Abschluss angefordert',
      COMPLETION_CONFIRMED: 'Abschluss bestätigt',
      LOCAL_DATA_CLEARED: 'Lokale Daten bereinigt',
    },
    auditActions: {
      CREATE: 'Angelegt',
      UPDATE: 'Geändert',
      DELETE: 'Gelöscht',
      LOGIN: 'Anmeldung',
      LOGOUT: 'Abmeldung',
      EXPORT: 'Exportiert',
      POST: 'Verarbeitet',
      APPROVE: 'Freigegeben',
      CANCEL: 'Abgebrochen',
      VIEW: 'Angesehen',
    },
    postprocess: {
      NOT_REQUIRED: 'Nicht erforderlich',
      REQUIRED: 'Erforderlich',
      IN_PROGRESS: 'In Bearbeitung',
      COMPLETED: 'Abgeschlossen',
    },
  },
  partnerRecord: {
    title: 'Fragebögen zu diesem Geschäftspartner',
    subtitle: 'Alle zugeordneten Durchführungen mit Status, Antworten, Medien und Ergebnissen.',
    empty: 'Für diesen Geschäftspartner wurde noch kein Fragebogen durchgeführt.',
    loadError: 'Die zugeordneten Fragebögen konnten nicht geladen werden.',
    open: 'Fragebogen öffnen',
  },
  legalHold: {
    title: 'Aufbewahrungssperre',
    statuses: {
      NONE: 'Keine Sperre',
      ACTIVE: 'Aktiv',
      EXPIRED: 'Abgelaufen',
    },
    noneDescription: 'Für diese Befragung besteht keine Aufbewahrungssperre.',
    indefinite: 'Unbefristet gesperrt',
    untilValue: 'Gesperrt bis {{value}}',
    set: 'Sperre setzen',
    change: 'Sperre ändern',
    release: 'Sperre aufheben',
    setTitle: 'Aufbewahrungssperre setzen',
    setDescription:
      'Eine aktive Sperre verhindert die automatische Bereinigung und Anonymisierung dieser Befragung.',
    reason: 'Grund der Aufbewahrungssperre',
    until: 'Gesperrt bis (optional)',
    untilHint: 'Ohne Endzeitpunkt bleibt die Sperre unbefristet aktiv.',
    untilInvalid: 'Der Endzeitpunkt muss in der Zukunft liegen.',
    confirmSet: 'Sperre verbindlich setzen',
    setSuccess: 'Die Aufbewahrungssperre wurde gespeichert.',
    saveError: 'Die Aufbewahrungssperre konnte nicht gespeichert werden.',
    releaseTitle: 'Aufbewahrungssperre aufheben',
    releaseDescription:
      'Nach dem Aufheben kann die Befragung wieder gemäß der Aufbewahrungsfrist bereinigt oder anonymisiert werden.',
    releaseReason: 'Begründung für die Aufhebung',
    confirmRelease: 'Sperre verbindlich aufheben',
    releaseSuccess: 'Die Aufbewahrungssperre wurde aufgehoben.',
    releaseError: 'Die Aufbewahrungssperre konnte nicht aufgehoben werden.',
    loadError: 'Die Aufbewahrungssperre konnte nicht geladen werden.',
  },
  settings: {
    title: 'Fragebogen-Einstellungen',
    subtitle: 'Mandantenweite Regeln für Aufbewahrung, Kundenmodus, Offline-Nutzung und Berichte.',
    loading: 'Fragebogen-Einstellungen werden geladen.',
    loadError: 'Die Fragebogen-Einstellungen konnten nicht geladen werden.',
    invalid: 'Bitte prüfen Sie die eingegebenen Werte.',
    saved: 'Die Fragebogen-Einstellungen wurden gespeichert.',
    saveError: 'Die Fragebogen-Einstellungen konnten nicht gespeichert werden.',
    retention: 'Aufbewahrung und Bereinigung',
    retentionDays: 'Aufbewahrungsfrist in Tagen',
    abandonedDraftCleanupDays: 'Verwaiste Entwürfe bereinigen nach Tagen',
    customerMode: 'Kundenmodus',
    customerSessionTtlMinutes: 'Maximale Sitzungsdauer in Minuten',
    customerIdleLockMinutes: 'Inaktivitätssperre in Minuten',
    offlineAndReports: 'Offline-Nutzung und Berichte',
    offlineCatalogMaxProducts: 'Maximal sicher vorzuladende Produkte',
    allowSensitiveOffline: 'Sensible Antworten verschlüsselt offline zulassen',
    createPdfOnCompletion: 'PDF-Bericht nach Abschluss erzeugen',
    attachPdfToPartner: 'PDF-Bericht in der Partnerakte sichtbar machen',
  },
} as const;
